import { __extends } from "tslib";
import { deepMix, isBoolean } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
import './interaction';
var Scatter = /** @class */ (function (_super) {
    __extends(Scatter, _super);
    function Scatter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 图表类型 */
        _this.type = 'point';
        return _this;
    }
    /**
     * 获取散点图的适配器
     */
    Scatter.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    Scatter.prototype.getDefaultOptions = function (options) {
        var shapeField = options.shapeField, colorField = options.colorField, legend = options.legend;
        return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
            size: 4,
            /** pointStyle 跟随主题默认样式 */
            tooltip: {
                shared: null,
                showTitle: false,
            },
            /**
             * legend 没有指定时根据 shapeField 和 colorField 来设置默认值
             */
            legend: isBoolean(legend) ? legend : legend || !!(shapeField || colorField),
        });
    };
    return Scatter;
}(Plot));
export { Scatter };
//# sourceMappingURL=index.js.map